import { useNavigate } from 'react-router-dom';
import BrandDetailsDialog from '../../BrandDetailsDialog';
import { addBrand } from '../../hooks/useBrands';
import { showToastError, showToastSuccess } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function AddBrandContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();

  return (
    <BrandDetailsDialog
      title="Add Brand"
      currentOrg={org}
      onClose={() => navigate('/brands', { replace: true })}
      onSave={async (brand) => {
        try {
          await addBrand(brand);
          showToastSuccess('Brand successfully added.');
          navigate('/brands', { replace: true });
        } catch (error) {
          showToastError('Brand could not be added.');
          console.error(error);
        }
      }}
    />
  );
}
